import { get } from "lodash-es";

// export default function useData ()
// {
export function getList ( field, data, datastore )
{
    if ( (!field.list_type || field.list_type === "value_list") && Array.isArray( field.value_list ) )
        return field.value_list;


    if ( field.list_type === "computed_list" && field.computed_list )
    {
        try
        {
            return eval( field.computed_list );
        }

        catch (e)
        {
            console.error( "Error in eval", e.message );
            console.error( "field.computed_list", field.computed_list );
        }


    }

    return [];
}

export function getValue ( field, data, path = "" )
{
    let childData = get( data, path )

    if ( childData === null )
    {
        return null;
    }

    let val = childData[ field.key ?? '' ];

    if ( val || val === 0 )
        return val;

    return null;
}


export function sprintf ( format, ...args )
{

    if ( typeof format === 'undefined' || !format )
    {
        return '';
    }


    let i = 0;

    let type = typeof (format);

    let strFormatted = format.replace( /%s/g, () => args[ i++ ] );

    return strFormatted;
}

//}

